

export class EmployeeDirectorDto implements IEmployeeDirectorDto {
    id!: number;
    empCode!: number;
    empName!: string | undefined;
    employeeName!: string | undefined;
    fatherName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IEmployeeDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empCode = _data["empCode"];
            this.empName = _data["empName"];
            this.employeeName = _data["employeeName"];
            this.fatherName = _data["fatherName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EmployeeDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empCode"] = this.empCode;
        data["empName"] = this.empName;
        data["employeeName"] = this.employeeName;
        data["fatherName"] = this.fatherName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IEmployeeDirectorDto {
    id: number;
    empCode: number;
    empName: string | undefined;
    employeeName: string | undefined;
    fatherName: string | undefined;
    isActive: boolean;
}

